import { formatToLocalDateDay, api } from '@/utils';

export default {
  name: 'MatchesOverviewTableItem',
  components: {},
  props: {
    item: {
      id: '',
      createdOn: '',
      updatedAt: '',
      oldestDossierId: 0,
      newestDossierId: 0,
      mergedDossierId: 0,
      oldestDossierNumber: '',
      newestDossierNumber: '',
      mergedDossierNumber: '',
      mergedBy: '',
      score: '',
      status: '',
      suggestionsForOldestDossier: 0,
      suggestionsForNewestDossier: 0,
      createdDossier: '',
      comparedFields: [
        {
          type: 'Client',
          oldestDossierElements: [
            {
              key: 'string',
              description: 'string',
            },
          ],
          newestDossierElements: [
            {
              key: 'string',
              description: 'string',
            },
          ],
          intersectElements: [
            {
              key: 'string',
              description: 'string',
            },
          ],
          unionElements: [
            {
              key: 'string',
              description: 'string',
            },
          ],
        },
      ],
      Merge: '',
    },
  },
  data: () => ({
    dossier1: {
      dossier: '',
      client: '',
      reference: '',
      vessel: '',
      terminal: '',
      suggestions: '',
      stakeholders: '',
      stakeholdersRef: '',
      products: '',
    },
    dossier2: {
      dossier: '',
      client: '',
      reference: '',
      vessel: '',
      terminal: '',
      suggestions: '',
      stakeholders: '',
      stakeholdersRef: '',
      products: '',
    },
    apiVersion: 1,
    clientClass: 'match-border--red',
    referenceClass: 'match-border--red',
    vesselClass: 'match-border--red',
    terminalClass: 'match-border--red',
    stakeholdersClass: 'match-border--red',
    stakeholdersRefClass: 'match-border--red',
    productsClass: 'match-border--red',
    scoreClass: 'match-info__color--red',
    statusClass: 'match-info__color--red',
    productsTitle: '',
    stakeholdersTitle: '',
    stakeholdersRefTitle: '',
  }),
  computed: {
    cleanedUpItem() {
      return {
        timestamp: formatToLocalDateDay(this.item.createdOn) || 'Empty',
        dossier1: this.item.oldestDossierNumber || 'Empty',
        dossier2: this.item.newestDossierNumber || 'Empty',
        mergedBy: this.item.mergedBy || 'Empty',
        score: this.item.score || '0',
        status: this.item.status || 'Empty',
      };
    },
  },
  methods: {
    getDossiers() {
      this.setMatchInfoClasses();

      this.dossier1 = {
        dossier: this.item.oldestDossierNumber || 'Empty',
        client: '' || 'Empty',
        reference: '' || 'Empty',
        vessel: '' || 'Empty',
        terminal: '' || 'Empty',
        suggestions: this.item.suggestionsForOldestDossier || '0',
        stakeholders: '' || '0/0  ',
        stakeholdersRef: '' || '0/0  ',
        products: '' || '0/0',
      };
      this.dossier2 = {
        dossier: this.item.newestDossierNumber || 'Empty',
        client: '' || 'Empty',
        reference: '' || 'Empty',
        vessel: '' || 'Empty',
        terminal: '' || 'Empty',
        suggestions: this.item.suggestionsForNewestDossier || '0',
        stakeholders: '' || '0/0',
        stakeholdersRef: '' || '0/0  ',
        products: '' || '0/0',
      };

      this.item.comparedFields.forEach((field) => {
        switch (field.type) {
          case 'Client':
            if (field.oldestDossierElements.length > 0) {
              this.dossier1.client = field.oldestDossierElements[0].description || 'Empty';
            }
            if (field.newestDossierElements.length > 0) {
              this.dossier2.client = field.newestDossierElements[0].description || 'Empty';
            }

            this.clientClass = this.compareFieldClasses(this.dossier1.client, this.dossier2.client);
            break;
          case 'Reference':
            if (field.intersectElements.length > 0) {
              this.dossier1.reference = field.intersectElements[0].description || 'Empty';
              this.dossier2.reference = field.intersectElements[0].description || 'Empty';
            } else {
              if (field.oldestDossierElements.length > 0) {
                this.dossier1.reference = field.oldestDossierElements[0].description || 'Empty';
              }
              if (field.newestDossierElements.length > 0) {
                this.dossier2.reference = field.newestDossierElements[0].description || 'Empty';
              }
            }

            this.referenceClass = this.compareFieldClasses(this.dossier1.reference, this.dossier2.reference);
            break;
          case 'Ship':
            if (field.oldestDossierElements.length > 0) {
              this.dossier1.vessel = field.oldestDossierElements[0].description || 'Empty';
            }
            if (field.newestDossierElements.length > 0) {
              this.dossier2.vessel = field.newestDossierElements[0].description || 'Empty';
            }

            this.vesselClass = this.compareFieldClasses(this.dossier1.vessel, this.dossier2.vessel);
            break;
          case 'Terminal':
            if (field.oldestDossierElements.length > 0) {
              this.dossier1.terminal = field.oldestDossierElements[0].description || 'Empty';
            }
            if (field.newestDossierElements.length > 0) {
              this.dossier2.terminal = field.newestDossierElements[0].description || 'Empty';
            }

            this.terminalClass = this.compareFieldClasses(this.dossier1.terminal, this.dossier2.terminal);
            break;
          case 'Stakeholder': {
            this.dossier1.stakeholders = `${field.intersectElements.length}/${field.oldestDossierElements.length}` || '0/0';
            this.dossier2.stakeholders = `${field.intersectElements.length}/${field.newestDossierElements.length}` || '0/0';

            this.stakeholdersClass = this.compareFieldClassesByField(field, field);
            const matchingStakeholders = field.intersectElements.map(el => el.description);
            const unionStakeholders = field.unionElements.map(el => el.description);

            if (matchingStakeholders.length > 0) {
              this.stakeholdersTitle = `Match: ${matchingStakeholders.join(', ')}`;
            }

            if (matchingStakeholders.length > 0 && unionStakeholders.length > 0) {
              this.stakeholdersTitle += ' | ';
            }

            if (unionStakeholders.length > 0) {
              this.stakeholdersTitle += `No Match: ${unionStakeholders.filter(sh => !matchingStakeholders.includes(sh)).join(', ')}`;
            }
            break;
          }
          case 'StakeholderReference': {
            this.dossier1.stakeholdersRef = `${field.intersectElements.length}/${field.oldestDossierElements.length}` || '0/0';
            this.dossier2.stakeholdersRef = `${field.intersectElements.length}/${field.newestDossierElements.length}` || '0/0';

            this.stakeholdersRefClass = this.compareFieldClassesByField(field, field);
            const matchingStakeholdersRef = field.intersectElements.map(el => el.description);
            const unionStakeholdersRef = field.unionElements.map(el => el.description);

            if (matchingStakeholdersRef.length > 0) {
              this.stakeholdersRefTitle = `Match: ${matchingStakeholdersRef.join(', ')}`;
            }

            if (matchingStakeholdersRef.length > 0 && unionStakeholdersRef.length > 0) {
              this.stakeholdersRefTitle += ' | ';
            }

            if (unionStakeholdersRef.length > 0) {
              this.stakeholdersRefTitle += `No Match: ${unionStakeholdersRef.filter(sh => !matchingStakeholdersRef.includes(sh)).join(', ')}`;
            }
            break;
          }
          case 'Product': {
            this.dossier1.products = `${field.intersectElements.length}/${field.oldestDossierElements.length}` || '0/0';
            this.dossier2.products = `${field.intersectElements.length}/${field.newestDossierElements.length}` || '0/0';

            this.productsClass = this.compareFieldClassesByField(field);
            const matchingProducts = field.intersectElements.map(el => el.description);
            const unionProducts = field.unionElements.map(el => el.description);
            if (matchingProducts.length > 0) {
              this.productsTitle = `Match: ${matchingProducts.join(', ')}`;
            }

            if (matchingProducts.length > 0 && unionProducts.length > 0) {
              this.productsTitle += ' | ';
            }

            if (unionProducts.length > 0) {
              this.productsTitle += `No Match: ${unionProducts.filter(sh => !matchingProducts.includes(sh)).join(', ')}`;
            }
            break;
          }
          default:
            break;
        }
      });
    },
    setMatchInfoClasses() {
      // status
      switch (this.item.status) {
        case 'Rejected':
        case 'Deprecated':
          this.statusClass = 'match-info__color--red';
          break;
        case 'Pending':
          this.statusClass = 'match-info__color--orange';
          break;
        case 'Merged':
          this.statusClass = 'match-info__color--green';
          break;
        default:
          this.statusClass = 'match-info__color--red';
          break;
      }

      // score
      if (this.item.score < 10) {
        this.scoreClass = 'match-info__color--red';
      } else if (this.item.score < 75) {
        this.scoreClass = 'match-info__color--orange';
      } else {
        this.scoreClass = 'match-info__color--green';
      }
    },
    compareFieldClassesByField(field) {
      if (field.oldestDossierElements.length === field.newestDossierElements.length) {
        if (field.intersectElements.length === 0) {
          return 'match-border--red';
        }
        return 'match-border--green';
      }
      return 'match-border--red';
    },
    compareFieldClasses(dossier1Field, dossier2Field) {
      if (dossier1Field === dossier2Field) {
        return 'match-border--green';
      }
      return 'match-border--red';
    },
    filterDossier(dossierNummer, oldDossier = false) {
      this.$eventHub.$emit('fetch-matching--dossier', {
        dossierNummer,
        oldDossier,
      });
    },
    mergeDossiers() {
      this.$eventHub.$emit('trigger-loading');

      const url = `/rule-engine/executions/${this.item.id}/accept`;

      api
        .post(url)
        .then(() => {
          this.$eventHub.$emit('fetch-matching');
        })
        .catch((error) => {
          this.$eventHub.$emit('error-matching', error);
        });
    },
    deleteDossiers() {
      this.$eventHub.$emit('trigger-loading');

      const url = `/rule-engine/executions/${this.item.id}/reject`;

      api
        .post(url)
        .then(() => {
          this.$eventHub.$emit('fetch-matching');
        })
        .catch((error) => {
          this.$eventHub.$emit('error-matching', error);
        });
    },
  },
  created() {
    this.getDossiers();
  },
};
